import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import endpoints from "../../endpoint";

// Async Thunk to Fetch Deals
export const fetchMyDeals = createAsyncThunk(
  "deals/fetchMyDeals",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${endpoints.serverBaseUrl}api/deals/my-deals`,
        {
          withCredentials: true,
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Failed to fetch deals");
    }
  }
);

const dealsSlice = createSlice({
  name: "deals",
  initialState: {
    deals: [],
    dealsCount: 0,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyDeals.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMyDeals.fulfilled, (state, action) => {
        state.loading = false;
        state.deals = action.payload;
        state.dealsCount = action.payload.length;
      })
      .addCase(fetchMyDeals.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default dealsSlice.reducer;
